const text = (value) => String(value ?? "").trim();

export function prescriptionLoadLabel(prescription) {
  const selectedBand = text(prescription.band_colour);
  const band = selectedBand && !/^none$/i.test(selectedBand) ? selectedBand : text(prescription.resistance);
  if (band && !/^none$/i.test(band)) {
    return /^(yellow|red|green|blue|black)$/i.test(band) ? `${band} TB` : band;
  }
  const equipment = text(prescription.equipment);
  if (!equipment || /^(none|n\/a)$/i.test(equipment)) return "";
  return /^(body ?weight|bw)$/i.test(equipment) ? "BW" : equipment;
}

export function resolvePlanPrescription(row) {
  const exercise = row.exercise || {};
  return {
    exercise_id: row.exercise_id || exercise.id || row.id,
    title: exercise.title || exercise.name || row.title || "Exercise",
    sets: row.sets ?? exercise.sets ?? "",
    reps: row.reps ?? exercise.reps ?? "",
    hold_time: row.hold_time ?? exercise.hold_time ?? "",
    frequency: row.frequency ?? exercise.frequency ?? "",
    band_colour: row.band_colour ?? "",
    resistance: row.resistance ?? "",
    equipment: row.equipment ?? exercise.equipment ?? "",
    instructions: row.instructions_override || row.instructions || exercise.instructions || exercise.description || "",
    key_cues: row.key_cues || exercise.technique_cues || exercise.key_cues || "",
    clinician_notes: row.patient_notes || "",
    safety_notes: row.safety_notes_override || exercise.safety_notes || "",
    description: exercise.description || row.description || "",
    thumbnail_url: exercise.thumbnail_url || row.thumbnail_url || "",
    youtube_video_id: exercise.youtube_video_id || row.youtube_video_id || "",
    video_url: exercise.video_url || row.video_url || "",
  };
}
